export const DEAL_CODE_PREFIX = 'DEAL:';

export const dealItemCode = (dealId: string): string => `${DEAL_CODE_PREFIX}${dealId}`;

export const isDealItem = (item?: { code?: string } | null): boolean =>
  String(item?.code || '').startsWith(DEAL_CODE_PREFIX);

export const dealToInvoiceItem = (deal: {
  _id: string;
  name: string;
  kind: 'RECURRING' | 'ONE_TIME';
  quantity: number;
  unitPrice: number;
}) => ({
  code: dealItemCode(deal._id),
  description: deal.kind === 'RECURRING' ? `${deal.name} — monthly` : deal.name,
  quantity: Number(deal.quantity) > 0 ? Number(deal.quantity) : 1,
  unitPrice: Number(deal.unitPrice) || 0
});

export const dealAmount = (deal: { quantity: number; unitPrice: number }): number =>
  Math.round((Number(deal.quantity) || 0) * (Number(deal.unitPrice) || 0) * 100) / 100;
